import { useRef, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useMutation } from '@apollo/client';
import { IContactPhone } from '../../../../types/contact';
import { GET_ORG_CONTACT_PHONES, UPDATE_ORG_CONTACT_PHONE } from '../../../../graphql/contact-gql';
import PhoneDetails, { PhoneHandler } from './phone-details';
import { notifySuccess } from '../../../../services/notification';
import { CancelIcon, SaveIcon } from '../../../common/icons';
import SpinnerOverlay from '../../../common/spinner/spinner';
import Button from '../../../common/button';

type PhoneUpdateProps = {
    isOpen: boolean;
    toggle: () => void;
    contactPhone?: IContactPhone;
}

const PhoneUpdate = (props: PhoneUpdateProps) => {
    const { isOpen, toggle, contactPhone } = props
    const contactRef = useRef<PhoneHandler>(null)

    const [updateContactPhone, {loading}] = useMutation(UPDATE_ORG_CONTACT_PHONE)

    const [validated, setValidated] = useState<boolean>(true)

    const saveContact = () => {
        if (contactRef.current && !contactRef.current.validate(true)) {
            setValidated(false)
            return
        }

        let contactPhoneInput = contactRef.current && contactRef.current.getContactPhone()

        updateContactPhone({
            variables: {
                orgId: contactPhone?.businessEntityId,
                input: contactPhoneInput
            },
            refetchQueries: [{
                query: GET_ORG_CONTACT_PHONES,
                variables: { orgId: contactPhone?.businessEntityId }
            }],
            awaitRefetchQueries: true,
            onCompleted: (data) => {
                toggle()
                data && notifySuccess()
            }
        })
    }

    const onToggle = (event: any) => {
        if (event.target.nodeName !== 'SELECT') {
            toggle()
        }
    }

    const onChange = () => {
        setValidated(!!contactRef.current?.validate(false))
    }

    return (<>
        {loading && <SpinnerOverlay />}
        <Modal size="lg" isOpen={isOpen} toggle={onToggle} scrollable autoFocus={false}>
            <ModalHeader toggle={toggle} tag={'h2'}>Update an Organization Phone Number</ModalHeader>
            <ModalBody>
                <PhoneDetails ref={contactRef} isOrgPhone={true} contactPhone={contactPhone} onChange={onChange} autoFocus={true}/>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={saveContact} disabled={!validated}><SaveIcon/> Update</Button>
                <Button color="secondary" onClick={toggle}><CancelIcon/> Cancel</Button>
            </ModalFooter>
        </Modal>
        </>
    )
}

export default PhoneUpdate
